export function uniq<T>(array: T[]): T[] {
  return uniqBy(array, (item) => item)
}

export function uniqBy<T, K>(
  array: T[],
  keyFn: (item: T, index: number, array: T[]) => K,
): T[] {
  const exisitingKeys = new Set<K>()

  return array.reduce((acc, item, index, array) => {
    const key = keyFn(item, index, array)
    if (!exisitingKeys.has(key)) {
      acc.push(item)
      exisitingKeys.add(key)
    }
    return acc
  }, [] as T[])
}
